export async function loadDisplay (type) {
  if (type === 'sequenceModele') {
    throw Error('Ce contenu ne peut être affiché ici, il ne peut être utilisé que dans Labomep (le glisser dans "Mes séquences" pour l’y dupliquer puis le modifier pour y ajouter des élèves)')
  }
  const module = await import(`@sesatheque-plugins/${type}/display`)
  if (typeof module.display === 'function') return module.display
  if (module) throw Error(`Le module ${type} n'exporte pas de fonction display, affichage impossible`)
  throw Error(`L'affichage des ressources de type ${type} n'est pas géré par cette bibliothèque de ressources`)
}

/**
 * Retourne les fct exportées par l'éditeur du plugin (ou un objet vide si le plugin ne fourni pas d'éditeur).
 * @param {string} type
 * @return {EditorExports}
 */
export const loadEditor = (type) => import(`@sesatheque-plugins/${type}/editor`)
  .catch(error => {
    console.error(error)
    throw Error(`L'édition des ressources de type ${type} n'est pas géré par cette bibliothèque de ressources`)
  })

/**
 * @typedef EditorExports
 * @property {function} [editor]
 * @property {function} [loadHook]
 * @property {function} [saveHook]
 * @property {function} [validate]
 */
